module.exports = __webpack_public_path__ + "assets/monitor.7eeb6217.svg";